import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { id: "ViewQuestionsView" }
const _hoisted_2 = { class: "docArea" }
const _hoisted_3 = { class: "docArea" }
const _hoisted_4 = { class: "docArea" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  QuestionControllerService,
  QuestionSubmitAddRequest,
  QuestionSubmitControllerService,
  QuestionSubmitVO,
  QuestionVO,
  WriteUpControllerService,
  WriteUpVO,
} from "../../generated";
import CodeEditor from "@/components/CodeEditor.vue";
import MdViewer from "@/components/MdViewer.vue";
import WriteUpCard from "@/components/WriteUpCard.vue";
import { useRouter } from "vue-router";
import moment from "moment/moment";
import { useStore } from "vuex";

interface Props {
  id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewQuestionView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const store = useStore();
const currUser = store.state.user.loginUser;
const question = ref<QuestionVO>();
const writeUpList = ref<Array<WriteUpVO>>();
const isPersonal = ref(false); //只看自己？
const languageOptions = [
  {
    value: "java",
    label: "Java",
  },
];

const props = __props;

const loadData = async () => {
  //拿到当前题目
  const questionRes = await QuestionControllerService.getQuestionVoByIdUsingGet(
    props.id as any
  );
  if (questionRes.code === 0) {
    question.value = questionRes.data;
  } else {
    message.error("加载失败！ " + questionRes.message);
  }

  //拿到当前题目通过审核的题解
  // 校验分页数量
  if (
    !writeUpSearchParams.value.pageSize ||
    writeUpSearchParams.value.pageSize <= 0
  ) {
    writeUpSearchParams.value.pageSize = 5;
  }
  const writeUpRes =
    await WriteUpControllerService.listWriteUpVoByPageUsingPost(
      writeUpSearchParams.value as any
    );
  if (writeUpRes.code === 0) {
    writeUpList.value = writeUpRes.data.records;
  } else {
    message.error("加载失败！ " + writeUpRes.message);
  }

  // 校验分页数量
  if (!searchParams.value.pageSize || searchParams.value.pageSize <= 0) {
    searchParams.value.pageSize = 5;
  }
  const questionSubmitRes =
    await QuestionSubmitControllerService.listQuestionSubmitByPageUsingPost(
      searchParams.value as any
    );
  if (questionSubmitRes.code === 0) {
    dataList.value = questionSubmitRes.data.records;
    total.value = questionSubmitRes.data.records.length;
  } else {
    message.error("加载数据失败！ " + questionSubmitRes.message);
  }
};
onMounted(() => {
  loadData();
});

const form = ref<QuestionSubmitAddRequest>({
  language: "java",
  code: "",
});
const onCodeChange = (v: string) => {
  form.value.code = v;
};
const doSubmit = async () => {
  if (props.id !== "" && form.value.code !== "") {
    const res = await QuestionSubmitControllerService.doQuestionSubmitUsingPost(
      {
        ...form.value,
        questionId: props.id as any,
      }
    );
    if (res.code === 0) {
      message.success("提交成功！");
    } else {
      message.error("提交失败！ " + res.message);
    }
  }
};
//题解相关
const writeUpSearchParams = ref({
  questionId: props.id,
  pageSize: 10,
  current: 1,
  reviewStatus: 1, //已审核通过
});
const toWriteWP = () => {
  router.push({
    path: `/add/writeUp/${props.id}`,
  });
};
//提交记录相关
const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  questionId: props.id,
  pageSize: 10,
  current: 1,
  userId: "", //只看自己？
});

// 监听分页变量，改变时更新页面
watchEffect(() => {
  loadData();
});

const columns = [
  {
    title: "记录id",
    dataIndex: "questionSubmitId",
  },
  {
    title: "提交者",
    slotName: "userVO",
  },
  {
    title: "语言",
    dataIndex: "language",
  },
  {
    title: "状态",
    slotName: "status",
  },
  {
    title: "提交时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];
// 跳转到做题页面
const router = useRouter();
const checkboxChange = () => {
  if (isPersonal.value) {
    searchParams.value = {
      ...searchParams.value,
      userId: currUser.userId as any,
    };
  }
};
const toDetail = (questionSubmit: QuestionSubmitVO) => {
  router.push({
    path: `/view/questionSubmit/${questionSubmit.questionSubmitId}`,
  });
};

const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: [24, 24] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              "default-active-key": "question",
              position: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "question",
                  title: "题目"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (question.value)
                        ? (_openBlock(), _createBlock(_component_a_card, {
                            key: 0,
                            bordered: false,
                            title: question.value.title,
                            style: {"margin-top":"10px","height":"95%","flex":"1"}
                          }, {
                            extra: _withCtx(() => [
                              _createVNode(_component_a_space, { wrap: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.tag, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_a_tag, {
                                      key: index,
                                      color: "green"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_descriptions, {
                                column: { xs: 1, md: 2, lg: 3 },
                                title: "题目限制"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tag, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(question.value.judgeConfig.timeLimit) + " ms", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tag, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(question.value.judgeConfig.memoryLimit) + " KB", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_descriptions_item, { label: "堆栈限制" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tag, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(question.value.judgeConfig.stackLimit) + " KB", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(MdViewer, {
                                value: question.value.content || ' '
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "answer",
                  title: "题解"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "题目题解", -1)),
                      _createVNode(_component_a_button, {
                        style: {"margin-top":"16px"},
                        type: "primary",
                        onClick: toWriteWP
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("编写题解 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_divider),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(writeUpList.value, (item, index) => {
                        return (_openBlock(), _createBlock(WriteUpCard, {
                          post: item,
                          key: index
                        }, null, 8, ["post"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "submits",
                  title: "提交记录"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[9] || (_cache[9] = _createElementVNode("h2", null, "提交记录", -1)),
                      _createVNode(_component_a_descriptions, {
                        column: { xs: 1, md: 2, lg: 3 },
                        title: "判题信息"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "题目标题" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(question.value?.title), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "题目ID" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(question.value?.questionId), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_checkbox, {
                            modelValue: isPersonal.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isPersonal).value = $event)),
                            onChange: checkboxChange
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("只看自己 ")
                            ])),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_divider, { size: 0 }),
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createTextVNode("每页题目数量 ")),
                          _createVNode(_component_a_input_number, {
                            modelValue: searchParams.value.pageSize,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.pageSize) = $event)),
                            min: "1",
                            placeholder: "每页提交记录数量",
                            size: "small",
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: loadData
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("刷新")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_divider, { size: 0 }),
                      _createVNode(_component_a_table, {
                        columns: columns,
                        data: dataList.value,
                        pagination: {
                  showTotal: true,
                  pageSize: searchParams.value.pageSize,
                  current: searchParams.value.current,
                  total: total.value,
                },
                        onPageChange: onPageChange
                      }, {
                        userVO: _withCtx(({ record }) => [
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.userVO.userName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        createTime: _withCtx(({ record }) => [
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD hh:mm:ss")), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        optional: _withCtx(({ record }) => [
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: ($event: any) => (toDetail(record))
                              }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("查看详情 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 8, ["data", "pagination"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24,
          class: "codeArea"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              column: { xs: 1, md: 2 },
              class: "operationLine"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_cascader, {
                      modelValue: form.value.language,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.language) = $event)),
                      options: languageOptions,
                      placeholder: "请选择代码语言",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 8,
                  style: {"margin-left":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      style: {"width":"200px"},
                      type: "primary",
                      onClick: doSubmit
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("提交代码 ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(CodeEditor, {
              ref: "monacoEdit",
              "handle-change": onCodeChange,
              language: form.value.language,
              readonly: false,
              value: form.value.code,
              style: {"height":"95%","flex":"1"}
            }, null, 8, ["language", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})